<template>
  <div id="app">
    <Popup />
    <TopBar v-if="hasTopBar()" />
    <Toast />
    <Transition name="upload-loader">
      <UploadLoader v-if="batchId" />
    </Transition>
    <router-view v-slot="{ Component }">
      <transition :name="transitionName" mode="out-in"> <component :is="Component"></component></transition>
    </router-view>
    <div v-if="false" class="loader" />
  </div>
</template>
<script>
import Popup from '@/components/popup';
import TopBar from '@/components/Topbar';
import Toast from '@/components/ToastComponent.vue';
import UploadLoader from '@/components/UploadLoader.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    UploadLoader,
    Toast,
    Popup,
    TopBar,
  },
  data() {
    return {
      transitionName: 'slide-right',
    };
  },
  computed: {
    ...mapGetters(['batchId']),
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      if (from.name === 'editOrganisation' && to.name === 'profile') {
        this.transitionName = 'slide-left';
      } else this.transitionName = to.meta.transitionName;
      next();
    });
  },
  mounted() {
    this.$store.dispatch('templates.fetch').then(templates => {
      templates.forEach(this.$addTemplateCss);
    });
  },
  methods: {
    hasTopBar() {
      return !this.$route.meta.noTopbar;
    },
  },
};
</script>

<style lang="scss">
body {
  background: #f9f9f9;
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p {
  min-height: 12px;
  margin: unset;
}

.upload-loader-enter-active,
.upload-loader-leave-active {
  transition: all 0.3s ease;
}

.upload-loader-enter-from,
.upload-loader-leave-to {
  opacity: 0;
  transform: translateY(60px);
}
</style>
